import Divider from "../../components/divider/divider";
import List from "../../components/list";
import RenderThisIf from "../../components/renderIf";
import Row from "../../components/row";
import Scrollable from "../../components/scrollable";
import Container from "./container";
import { useMediaQuery } from 'react-responsive';

export default function Table(props) {
    const { 
        scrollableProps = {}, 
        scrollable = null, 
        columns, 
        data, 
        className, 
        style = {}, 
        rowStyle = {}, 
        replaceColumn,
        isEmpty = false,
        ifEmpty = null,
        showMobileColumns = false,
        headerColor = 'white',
        valueColor = 'white'
    } = props;

    const isMobile = useMediaQuery({
        query: '(min-width: 700px)'
    });

    let columnIndex = 0;
    
    const renderRow = (row, index) => {
        return (
            <div key={index} className="container-table__row" style={rowStyle}>
                { row?.map((rowData, rowIndex) => {
                    const { width } = columns[rowIndex];

                    columnIndex++;

                    const isRowReplaceable = replaceColumn?.hasOwnProperty(rowIndex);

                    if (isRowReplaceable) {
                        return <div key={rowIndex} className="container-table-row__cell" style={{ width }}>{ replaceColumn[rowIndex](rowData, row) }</div>
                    }

                    return <div key={rowIndex} className="container-table-row__cell" style={{ width }}>{ rowData }</div>
                }) }
            </div>
        )
    }

    const Wrapper = scrollable !== null ? ({ children }) => <Scrollable { ...scrollableProps }>{ children }</Scrollable> : ({ children }) => <>{ children }</>

    if (showMobileColumns) {
        if (!isMobile) {
            return (
                <List gap="30px" divider={<Divider color="#ebebeb" top="0px" bottom="0px"/>}>
                    { data?.map((item, index) => {
                        return (
                            <List gap="20px">
                                { columns.map((column, index2) => {
                                    return (
                                        <Row gap="5px">
                                            <div className="container-table__header" style={{ color: headerColor }}>{ column?.field }: </div>
                                            <div className="container-table-row__cell" style={{ color: valueColor }}>{ item[index2] }</div>
                                        </Row>
                                    )
                                })}
                            </List>
                        )
                    }) }
                </List>
            )
        }

        if (isMobile) {
            return (
                <>
                    <Container.Text className="utils__render-mobile" style={{ marginBottom: '10px', filter: 'invert(1)' }}>(Touch and drag to scroll inside table)</Container.Text>
        
                    <div className={`container-table ${className}`} style={style}>
                        <div className='container-table__headers'>
                            { columns.map((column, index) => {
                                let style = {}
        
                                if (column?.width) style.width = column.width;
        
                                return <div key={index} className="container-table__header" style={style}>{ column?.field }</div>
                            })}
                        </div>
                        
                        <RenderThisIf
                            renderIf={isEmpty}
                            render={ifEmpty}
                        >
                            <Wrapper>
                                <div className="container-table__rows">
                                    { data.map((row, index) => {
                                        return renderRow(row, index)
                                    })}
                                </div>
                            </Wrapper>
                        </RenderThisIf>
                    </div>
                </>
            )
        }
    }

    if (!showMobileColumns) {
        return (
            <>
                <Container.Text className="utils__render-mobile" style={{ marginBottom: '10px', filter: 'invert(1)' }}>(Touch and drag to scroll inside table)</Container.Text>
    
                <div className={`container-table ${className}`} style={style}>
                    <div className='container-table__headers'>
                        { columns.map((column, index) => {
                            let style = {}
    
                            if (column?.width) style.width = column.width;
    
                            return <div key={index} className="container-table__header" style={style}>{ column?.field }</div>
                        })}
                    </div>
                    
                    <RenderThisIf
                        renderIf={isEmpty}
                        render={ifEmpty}
                    >
                        <Wrapper>
                            <div className="container-table__rows">
                                { data.map((row, index) => {
                                    return renderRow(row, index)
                                })}
                            </div>
                        </Wrapper>
                    </RenderThisIf>
                </div>
            </>
        )
    }
}

Table.DefaultProps = {
    columns: [],
    data: [],
    className: '',
    replaceColumn: {},
    style: {},
}